// Traductions de l'outil : window.PTX_T (texte français → traduction), écrit par le thème hors français.
var ptxT = window.ptxT || (window.ptxT = (s) => (window.PTX_T && window.PTX_T[s]) || s);
/*
 * Commande de feuilles DTF 35 × 40 cm (snippet printtex-dtf.liquid).
 * - Vérifie le fichier dans le navigateur : format, dimensions/résolution, fond transparent, semi-transparence.
 * - Choisit la variante « Palier » selon la quantité et affiche le prix.
 * - Ajoute au panier avec le fichier en propriété de ligne (PNG : lien Firebase Storage, téléchargé tel quel ;
 *   PDF : stocké par Shopify) ; quantité verrouillée
 *   dans le panier grâce à « _Référence design » (le palier dépend de la quantité).
 */
(() => {
  const root = document.querySelector('[data-pdtf]');
  if (!root) return;
  const cfg = window.PrinttexDTF || {};
  const $ = (s) => root.querySelector(s);
  const FEUILLE_CM = [35, 40];
  const MAX_MO = 20;

  /* Feuille PNG déposée dans Firebase Storage (projet printtex-commande, règle « perso » : dépôt seul, PNG
     uniquement, lecture par lien exact). Shopify convertit ses images en WebP quand on les ouvre depuis l'admin
     (illisible par GTX Graphics Lab) ; Firebase renvoie le PNG tel quel et le fait télécharger sous son nom. */
  const BUCKET = 'printtex-commande.firebasestorage.app';
  async function deposerPng(blob, nom) {
    const chemin = `perso/${crypto.randomUUID()}/${nom}`;
    const sep = `printtex${Date.now().toString(36)}`;
    const meta = JSON.stringify({ name: chemin, contentType: 'image/png', contentDisposition: `attachment; filename="${nom}"` });
    const corps = new Blob([
      `--${sep}\r\nContent-Type: application/json; charset=utf-8\r\n\r\n${meta}\r\n--${sep}\r\nContent-Type: image/png\r\n\r\n`,
      blob, `\r\n--${sep}--`,
    ]);
    const r = await fetch(`https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o?name=${encodeURIComponent(chemin)}`, {
      method: 'POST', signal: AbortSignal.timeout ? AbortSignal.timeout(60000) : undefined, // jamais « Envoi… » sans fin
      headers: { 'X-Goog-Upload-Protocol': 'multipart', 'Content-Type': `multipart/related; boundary=${sep}` },
      body: corps,
    }).catch(() => { throw new Error(ptxT("envoi du fichier interrompu (réseau lent ou coupé)")); });
    if (!r.ok) throw new Error(`${ptxT("envoi du fichier refusé (")}${r.status})`);
    const j = await r.json();
    return `https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o/${encodeURIComponent(chemin)}?alt=media&token=${j.downloadTokens}`;
  }
  const nomPng = (n) => `DTF-35x40cm_${String(n).replace(/\.png$/i, '').replace(/œ/g, 'oe').replace(/Œ/g, 'OE').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^A-Za-z0-9,_-]+/g, '-').replace(/^-|-$/g, '').slice(0, 150) || 'feuille'}.png`;

  const tiers = [...root.querySelectorAll('[data-tier]')].map((el) => ({
    el, min: +el.dataset.min, id: el.dataset.variant, price: +el.dataset.price,
    idX: el.dataset.variantExpress, priceX: +el.dataset.priceExpress,
  }));
  // Option Express disponible seulement si le produit a les variantes « Délai : Express ».
  const avecExpress = tiers.every((t) => t.idX);
  const express = () => avecExpress && root.querySelector('[data-delai]:checked')?.value === 'express';
  const prixDe = (t) => (express() ? t.priceX : t.price);
  const idDe = (t) => (express() ? t.idX : t.id);
  if (avecExpress) {
    $('[data-delai-bloc]').hidden = false;
    $('[data-express-sup]').textContent = `(+${((tiers[0].priceX - tiers[0].price) / 100).toLocaleString('fr-FR')} ${ptxT("€ par feuille)")}`;
    root.querySelectorAll('[data-delai]').forEach((r) => r.addEventListener('change', () => refresh()));
  }

  const fileInput = $('[data-file]');
  const drop = $('[data-drop]');
  const dropText = $('[data-drop-text]');
  const verif = $('[data-verif]');
  const later = $('[data-later]');
  const qtyInput = $('[data-qty]');
  const addBtn = $('[data-add]');
  const errorEl = $('[data-error]');
  let file = null; let depot = null;
  let bloquant = false;
  let resume = '';

  const euros = (cents) => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  const tierFor = (q) => tiers.filter((t) => q >= t.min).pop() || tiers[0];
  const qty = () => Math.min(100, Math.max(1, parseInt(qtyInput.value, 10) || 1));

  function refresh() {
    const q = qty();
    const t = tierFor(q);
    tiers.forEach((x) => {
      x.el.classList.toggle('is-active', x === t);
      x.el.querySelector('strong').textContent = euros(prixDe(x));
    });
    $('[data-unit]').textContent = `${q} feuille${q > 1 ? 's' : ''} × ${euros(prixDe(t))}`;
    $('[data-sum]').textContent = euros(prixDe(t) * q);
    addBtn.disabled = bloquant || !(file || later.checked);
  }

  function ligne(etat, texte) {
    const li = document.createElement('li');
    li.className = `is-${etat}`;
    li.textContent = `${{ ok: '✔', warn: '⚠', ko: '✖', info: 'ℹ' }[etat]} ${texte}`;
    verif.appendChild(li);
    return etat;
  }

  async function analyser(f) {
    verif.innerHTML = '';
    verif.hidden = false;
    bloquant = false;
    const etats = [];
    const mo = f.size / 1048576;
    dropText.innerHTML = `<strong>${f.name.replace(/[<>&]/g, '')}</strong><br><small>${mo.toFixed(1)} ${ptxT("Mo · cliquez pour changer")}</small>`;
    if (mo > MAX_MO) {
      bloquant = true;
      ligne('ko', `${ptxT("Fichier trop lourd (")}${mo.toFixed(0)} ${ptxT("Mo >")} ${MAX_MO} ${ptxT("Mo) : cochez « Je l'envoie après la commande » ci-dessous.")}`);
      return 'Fichier trop lourd'; // résumé « Vérification auto » lu par l'atelier : en français // résumé « Vérification auto » lu par l'atelier : en français
    }
    if (f.type === 'application/pdf') {
      ligne('ok', ptxT("PDF reçu"));
      ligne('info', ptxT("Les PDF sont contrôlés à la main par l'atelier avant impression (gratuit)."));
      return 'PDF, contrôle manuel';
    }
    if (f.type !== 'image/png') {
      bloquant = true;
      ligne('ko', ptxT("Format non accepté : envoyez un PNG (fond transparent) ou un PDF."));
      return 'Format refusé';
    }
    const img = await new Promise((res, rej) => {
      const i = new Image();
      i.onload = () => res(i);
      i.onerror = () => rej(new Error(ptxT("image illisible")));
      i.src = URL.createObjectURL(f);
    }).catch(() => null);
    if (!img) {
      bloquant = true;
      ligne('ko', ptxT("Image illisible : vérifiez votre fichier."));
      return 'Image illisible';
    }
    const { naturalWidth: w, naturalHeight: h } = img;
    // Feuille en portrait (35 × 40) ou paysage (40 × 35) selon le sens du fichier.
    const [cw, ch] = w <= h ? FEUILLE_CM : [...FEUILLE_CM].reverse();
    const dpi = Math.round(Math.min(w / (cw / 2.54), h / (ch / 2.54)));
    const ecartRatio = Math.abs(w / h - cw / ch) / (cw / ch);
    etats.push(ecartRatio < 0.03
      ? ligne('ok', `${ptxT("Proportions de la feuille respectées (")}${w} × ${h} px)`)
      : ligne('warn', `${ptxT("Proportions différentes de 35 × 40 cm (")}${w} × ${h} ${ptxT("px) : votre visuel sera centré sans être déformé.")}`));
    etats.push(dpi >= 250
      ? ligne('ok', `${ptxT("Résolution :")} ${Math.round(dpi)} dpi`)
      : dpi >= 150
        ? ligne('warn', `${ptxT("Résolution :")} ${Math.round(dpi)} ${ptxT("dpi (300 conseillés) : rendu correct, légèrement moins net.")}`)
        : ligne('ko', `${ptxT("Résolution :")} ${Math.round(dpi)} ${ptxT("dpi : rendu flou probable. Utilisez une image plus grande (4134 × 4724 px idéalement).")}`));

    // Transparence : analyse sur une version réduite de l'image.
    const k = Math.min(1, 500 / Math.max(w, h));
    const c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * k));
    c.height = Math.max(1, Math.round(h * k));
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, c.width, c.height);
    const px = ctx.getImageData(0, 0, c.width, c.height).data;
    let transparent = 0, semi = 0, plein = 0;
    for (let i = 3; i < px.length; i += 4) {
      if (px[i] === 0) transparent++;
      else if (px[i] === 255) plein++;
      else semi++;
    }
    URL.revokeObjectURL(img.src);
    const total = px.length / 4;
    if (transparent / total < 0.02) {
      etats.push(ligne('warn', ptxT("Fond non transparent : tout le rectangle sera imprimé (fond compris). Supprimez le fond si ce n'est pas voulu.")));
    } else {
      etats.push(ligne('ok', ptxT("Fond transparent")));
    }
    if (plein === 0 && semi === 0) {
      bloquant = true;
      etats.push(ligne('ko', ptxT("Le fichier est vide (entièrement transparent).")));
    } else if (semi / (semi + plein) > 0.15) {
      etats.push(ligne('warn', ptxT("Beaucoup de zones semi-transparentes (ombres, dégradés vers le transparent) : elles ressortent moins bien en DTF. L'atelier vous contactera si besoin.")));
    }
    ligne('info', ptxT("L'atelier contrôle aussi chaque fichier avant impression (gratuit)."));
    const n = etats.filter((e) => e === 'warn' || e === 'ko').length;
    return `PNG ${w} × ${h} px, ${Math.round(dpi)} dpi${n ? `, ${n} point(s) à vérifier` : ', conforme'}`;
  }

  async function choisir(f) {
    if (!f) return;
    file = f;
    errorEl.hidden = true;
    later.checked = false;
    resume = await analyser(f);
    if (bloquant) file = null;
    // Chef 28/10 : le PNG part dès le choix (ajout au panier plus rapide) ; le clic attend ce dépôt et le refait s'il a échoué.
    if (file && file.type === 'image/png') { depot = { f: file, p: deposerPng(file, nomPng(file.name)) }; depot.p.catch(() => {}); }
    refresh();
  }

  fileInput.addEventListener('change', () => choisir(fileInput.files[0]));
  // Fichier préparé sur la page « Préparer mon visuel » (printtex-visuel-transfert.js) : repris une seule fois.
  if (window.ptxTransfert) window.ptxTransfert.reprendre('dtf').then((f) => f && choisir(f)).catch(() => {});
  ['dragenter', 'dragover'].forEach((e) => drop.addEventListener(e, (ev) => { ev.preventDefault(); drop.classList.add('is-over'); }));
  ['dragleave', 'drop'].forEach((e) => drop.addEventListener(e, (ev) => { ev.preventDefault(); drop.classList.remove('is-over'); }));
  drop.addEventListener('drop', (ev) => choisir(ev.dataTransfer.files[0]));
  later.addEventListener('change', () => {
    if (later.checked) { file = null; bloquant = false; verif.hidden = true; fileInput.value = ''; dropText.innerHTML = `<strong>${ptxT("Fichier envoyé par e-mail après la commande")}</strong><br><small>${ptxT("Indiquez votre numéro de commande dans l'e-mail")}</small>`; }
    refresh();
  });
  $('[data-moins]').addEventListener('click', () => { qtyInput.value = qty() - 1; refresh(); });
  $('[data-plus]').addEventListener('click', () => { qtyInput.value = qty() + 1; refresh(); });
  qtyInput.addEventListener('input', refresh);
  qtyInput.addEventListener('change', () => { qtyInput.value = qty(); refresh(); });

  addBtn.addEventListener('click', async () => {
    const q = qty();
    const t = tierFor(q);
    addBtn.disabled = true;
    addBtn.textContent = file && file.size > 5e6 ? ptxT("Envoi du fichier…") : ptxT("Ajout…");
    try {
      const fd = new FormData();
      fd.append('id', idDe(t));
      fd.append('quantity', q);
      fd.append('properties[Format]', '35 × 40 cm');
      if (file) {
        // « Fichier » = nom lisible (vu par le client) ; « _Fichier » = lien pour l'atelier, caché au paiement et
        // dans les mails. PNG : lien Firebase (un clic = le PNG téléchargé tel quel) ; PDF : fichier Shopify.
        fd.append('properties[Fichier]', file.type === 'image/png' ? nomPng(file.name) : file.name);
        if (file.type === 'image/png') fd.append('properties[_Fichier]', await (depot?.f === file ? depot.p : Promise.reject()).catch(() => deposerPng(file, nomPng(file.name))));
        else fd.append('properties[_Fichier]', file, file.name);
        fd.append('properties[Vérification auto]', resume);
      } else {
        fd.append('properties[Fichier]', 'Envoyé par e-mail après la commande');
      }
      const note = $('[data-note]').value.trim();
      if (note) fd.append('properties[Remarque]', note);
      fd.append('properties[Tarif]', `${t.el.querySelector('span').textContent} (${euros(prixDe(t))} la feuille)`);
      fd.append('properties[_Référence design]', `D${Date.now().toString(36).toUpperCase()}`);
      const res = await fetch(cfg.cartAddUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      const out = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(out.description || out.message || `erreur ${res.status}`);
      addBtn.classList.add('is-done');
      addBtn.textContent = ptxT("✓ Ajouté au panier");
      setTimeout(() => { window.location.href = cfg.cartUrl; }, 600);
    } catch (e) {
      errorEl.textContent = `${ptxT("L'ajout au panier a échoué :")} ${e.message}. Réessayez ou appelez-nous au 01 86 04 31 65.`;
      errorEl.hidden = false;
      addBtn.textContent = ptxT("Ajouter au panier");
      refresh();
    }
  });

  refresh();
})();
